import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';

import dayjs from 'dayjs';
import { Box, Grid } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { Modal, TextField, Button } from 'shared';
import { editPurchaseModalStyles } from '../../style/style';

const EditPurchaseModal = ({ open, onClose, data, onEditCallback }) => {
    const { id: companyId } = useSelector((state) => state.company.data);
    const [formData, setFormData] = useState({});
    const classes = editPurchaseModalStyles();

    useEffect(() => {
        if (data && open) {
            setFormData({ ...data });
        }
    }, [data, open]);

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleSave = () => {
        const payload = {
            company_id: companyId,
            aggregated_file_inventory_id: formData.id,
            purchase_id: formData.purchase_id,
            class_1: formData.class_1,
            class_2: formData.class_2,
            seats: formData.seats,
            reference_id: formData.reference_id,
            description: formData.description,
            venue: formData.venue,
            purchase_price: formData.purchase_price,
            purchased_at: formData.purchased_at,
            expires_at: formData.expires_at,
        };

        if (onEditCallback) {
            onEditCallback(payload);
        }
        onClose();
    };

    return (
        <Modal open={open} handleClose={onClose} title="Edit Payment" maxWidth="sm">
            <Box p={3}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date"
                                value={formData.purchased_at ? dayjs(formData.purchased_at) : null}
                                onChange={(date) =>
                                    handleChange(
                                        'purchased_at',
                                        date ? date.format('YYYY-MM-DD') : '',
                                    )
                                }
                                slotProps={{ textField: { fullWidth: true } }}
                                sx={classes.datePicker}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Amount"
                            value={formData.purchase_price || ''}
                            onChange={(e) => handleChange('purchase_price', e.target.value)}
                            placeholder="0.00"
                            type="number"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Venue"
                            value={formData.venue || ''}
                            onChange={(e) => handleChange('venue', e.target.value)}
                            placeholder="venue"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Description"
                            value={formData.description || ''}
                            onChange={(e) => handleChange('description', e.target.value)}
                            placeholder="Description"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Row"
                            value={formData.class_2 || ''}
                            onChange={(e) => handleChange('class_2', e.target.value)}
                            placeholder="Row"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Section"
                            value={formData.class_1 || ''}
                            onChange={(e) => handleChange('class_1', e.target.value)}
                            placeholder="section"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Seats"
                            value={formData.seats || ''}
                            onChange={(e) => handleChange('seats', e.target.value)}
                            placeholder="seats"
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Purchase ID"
                            value={formData.purchase_id || ''}
                            onChange={(e) => handleChange('purchase_id', e.target.value)}
                            placeholder="Purchase ID"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Reference ID"
                            value={formData.reference_id || ''}
                            onChange={(e) => handleChange('reference_id', e.target.value)}
                            placeholder="Reference ID"
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
                    <Button
                        text="Cancel"
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            fontWeight: '500',
                            fontSize: '14px',
                            color: '#6C727F',
                            border: '1px solid #E5E6EB',
                            textTransform: 'none',
                        }}
                    />
                    <Button text="Save" onClick={handleSave} />
                </Box>
            </Box>
        </Modal>
    );
};

export default EditPurchaseModal;
